"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceDetect = void 0;

var _react = require("react");

var MOBILE_DEVICES = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i;

var getUserAgent = function getUserAgent() {
  return typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
};

var isMobileDevice = function isMobileDevice(userAgent) {
  return Boolean(userAgent.match(MOBILE_DEVICES));
};

var useDeviceDetect = function useDeviceDetect() {
  var _ref = (0, _react.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      isMobile = _ref2[0],
      setIsMobile = _ref2[1];

  (0, _react.useEffect)(function () {
    var userAgent = getUserAgent();
    setIsMobile(isMobileDevice(userAgent));
  }, []);
  return {
    isMobile: isMobile
  };
};

exports.useDeviceDetect = useDeviceDetect;